import getBooks from '../api/get/getBooks';

const fetchBooksAndShowNews = async () => {
    try {
        const [booksAudio, songsAudio] = await Promise.all([
            getBooks('bookAudio'),
            getBooks('songAudio'),
        ]);

        const allBooks = [...(booksAudio || []), ...(songsAudio || [])];
        if (allBooks.length === 0) return null;

        const lastCheckStr = localStorage.getItem('lastNewsCheckTime');
        const lastCheckTime = lastCheckStr ? new Date(lastCheckStr) : new Date(0);

        const shownBooksJson = localStorage.getItem('shownBooksIds');
        const shownBooksIds = shownBooksJson ? JSON.parse(shownBooksJson) : [];

        const newBooks = allBooks.filter(
            book => new Date(book.addedTime) > lastCheckTime && !shownBooksIds.includes(book.id)
        );
        if (newBooks.length === 0) return null;

        const updatedShownBooksIds = [...shownBooksIds, ...newBooks.map(b => b.id)];
        localStorage.setItem('shownBooksIds', JSON.stringify(updatedShownBooksIds));
        localStorage.setItem('lastNewsCheckTime', new Date().toISOString());

        return {
            title: `Жаңа кітаптар (${newBooks.length})`,
            description: newBooks.map(b => ({
                title: b.title,
                image: b.imageUrl || null,
            })),
        };
    } catch (error) {
        console.error('Кітаптарды жүктеу кезінде қате:', error);
        return null;
    }
};

export default fetchBooksAndShowNews;